import React, { useMemo } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { ColDef, themeAlpine, AllCommunityModule, ModuleRegistry } from 'ag-grid-community';

interface Props<T> {
    rows: T[];
    columnDefs: ColDef<T>[];
    onSelect: (row: T) => void;
    loading?: boolean;
}

export default function ConditionList<T>({ rows, columnDefs, onSelect, loading }: Props<T>): JSX.Element {
    ModuleRegistry.registerModules([AllCommunityModule]);

    return (
        <div style={{ width: '100%', maxHeight: '75vh', minHeight: '15em', position: 'relative' }}>
            {loading && (
                <div style={{
                    position: 'absolute', inset: 0, zIndex: 10,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    background: 'rgba(255,255,255,0.75)',
                }}>
                    <div style={{
                        width: 32, height: 32, borderRadius: '50%',
                        border: '3px solid #ccc', borderTopColor: '#005DB4',
                        animation: 'spin 0.8s linear infinite',
                    }} />
                    <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
                </div>
            )}
            <AgGridReact<T>
                rowData={rows}
                columnDefs={columnDefs}
                domLayout='autoHeight'
                theme={themeAlpine}
                rowSelection={{ mode: 'singleRow', enableClickSelection: !loading, checkboxes: false }}
                onRowDoubleClicked={e => { if (e.data && !loading) onSelect(e.data); }}
            />
        </div>
    );
}
